<!--
 * @Description: 人员详情证书信息组件
 * @Author: gaohc
 * @Date: 2022-11-29 11:01:35
-->
<template>
  <div class="certInfo-wrap">
    <div class="header">
      <img src="../../../../assets/instmng/attendantlist/img-attendant-certinfo.png" alt="" />
      <div>电子证书</div>
    </div>
    <div class="cert-text">本平台证书</div>
    <el-row type="flex" v-if="thisPlatformCertificateList && thisPlatformCertificateList.length" class="row-bg cert-wrap">
      <el-col :span="8" v-for="(item, idx) in thisPlatformCertificateList" :key="idx">
        <div class="grid-content bg-purple cert-div">
          <div class="cert-image-container" 
            :class="item.certificate.beOverdue ? 'expired-cert' : 'adopt-cert'">
            <div class="title-wrap">
              <img :src="item.certificate.type == 1 
                ? require('../../../../assets/instmng/attendantlist/icon-attendant-health-cert-head.png') 
                : require('../../../../assets/instmng/attendantlist/icon-attendant-cert-head.png')" 
                alt="">
              <span v-if="item.certificate.type == 1">健康证</span>
              <span v-else-if="item.certificate.type == 3">
                {{item.certificate.name}}
              </span>
              <span v-else>
                {{item.certificate.certTypeText}}
              </span>
            </div>
            <el-image class="cert-image" :src="loadImage(item.certificate.imgPath)"
              :preview-src-list="previewImgList">
            </el-image>
            <div style="max-width: 250px">
              <div>
                <span>证书有效期：</span>
                <span v-if="item.certificate.permanent">长期有效</span>
                <span v-else>
                  {{formateDate(item.certificate.startDate)}}-{{formateDate(item.certificate.endDate)}}
                </span>
              </div>
              <div class="review-time">
                <span>审核时间：</span>
                <span>
                  {{item.review && item.review.reviewTime ? item.review.reviewTime : '- -'}}
                </span>
              </div>
              <div v-if="!item.certificate.beOverdue">
                <span>审核人：</span>
                <span>
                  {{item.review && item.review.reviewerText ? item.review.reviewerText : '- -'}}
                </span>
              </div>
              <div v-else class="expired-cert-tag">过期证书需护工本人在APP中重新上传</div>
            </div>
            <img class="review-status-icon" :src="!item.certificate.beOverdue 
              ? require('../../../../assets/instmng/attendantlist/img-attendant-cert-adopt.png') 
              : require('../../../../assets/instmng/attendantlist/img-attendant-cert-expired.png')" 
              alt="">
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty v-else :image-size="180"></el-empty>
    <div class="extranetcert-text-wrap">
      <span>外联平台证书</span>
      <div slot="reference" class="sync-btn-wrap">
        <el-button type="primary" @click="handleSyncBtnClick" size="small" icon="el-icon-sync-cert">
          同步
        </el-button>
        <el-popover placement="bottom-start" width="440" trigger="click">
          <el-table class="sync-cert-table" :data="syncHistoryData">
            <el-table-column width="160" property="syncTime" label="同步时间"></el-table-column>
            <el-table-column width="70" label="结果">
              <template slot-scope="scope">
                <span>{{scope.row.result  ? '成功' : '失败'}}</span>
              </template>
            </el-table-column>
            <el-table-column width="85" label="操作人">
              <template slot-scope="scope">
                <span>{{scope.row.operator  ? scope.row.operator : '- -'}}</span>
              </template>
            </el-table-column>
            <el-table-column width="120" property="remark" label="备注"></el-table-column>
          </el-table>
          <i slot="reference" class="el-icon-arrow-down drop-icon" @click="handleGetSyncHistory"></i>
        </el-popover>
      </div>
    </div>
    <el-row v-if="outerPlatformCertificateList && outerPlatformCertificateList.length" type="flex" class="row-bg cert-wrap">
      <el-col :span="8" v-for="(item, idx) in outerPlatformCertificateList" :key="idx">
        <div class="grid-content bg-purple cert-div">
          <div class="cert-image-container" 
            :class="item.beOverdue ? 'expired-cert' : 'adopt-cert'">
            <div class="title-wrap">
              <img :src="item.type == 1 
                ? require('../../../../assets/instmng/attendantlist/icon-attendant-health-cert-head.png') 
                : require('../../../../assets/instmng/attendantlist/icon-attendant-cert-head.png')" 
                alt="">
              <span>{{item.name}}</span>
            </div>
            <osis-cert :certData="item" class="osis-cert" />
            <div style="max-width: 250px">
              <div>
                <span>证书有效期：</span>
                <span v-if="item.permanent">长期有效</span>
                <span v-else>
                  {{formateDate(item.startDate)}}-{{formateDate(item.endDate)}}
                </span>
              </div>
              <div class="review-time">
                <span>同步时间：</span>
                <span>{{item.uploadTime ? item.uploadTime : '- -'}}</span>
              </div>
              <div>
                <span>来源：</span>
                <span>{{item.sourceText ? item.sourceText : '- -'}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty v-else :image-size="180"></el-empty>
  </div>
</template>

<script>

import OsisCert from '../../../review/components/attendantReviewDetails/OsisCertificate.vue'
export default {
	props: ["thisPlatformCertificateList", "outerPlatformCertificateList", "syncHistoryData"],
  
  components: {
    "osis-cert": OsisCert
  },

  computed: {
    loadImage() {
      return (logoPath) => {
        return logoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, logoPath)
          : '';
      };
    },

    formateDate() {
      return function (date) {
        if (date) return this.dateUtil.dateFormat(date, "YYYY-MM-DD", ".");
      };
    },

    previewImgList() {
      let certList = this.thisPlatformCertificateList;
      if (certList && certList.length) {
        return this.getPreviewImageList(certList)
      }
    }
  },

  methods: {
    //同步证书数据按钮触发
    handleSyncBtnClick() {
      this.$emit("handle-sync-data");
    },

    //同步历史图标触发
    handleGetSyncHistory() {
      this.$emit("handle-get-sync-history");
    },

    //筛选数组中有效路径图片并放在预览图片数组中
    getPreviewImageList(list) {
      let imageList = [];
      list.forEach((item)=> {
        if(item.certificate.imgPath) {
          imageList.push(this.commonUtil.fillUrlArgments
          (this.commonUrl.URL_DOWNLOAD_FILE, item.certificate.imgPath))
        }
      })
      return imageList;
    }
  }
}
</script>

<style scoped>
.certInfo-wrap {
  background: #f7f9fe;
  padding: 30px 25px 18px 25px;
  margin: 0 25px;
}

.certInfo-wrap .header {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #000000;
  font-size: 22px;
}

.header img {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}
.cert-text {
  margin: 20px 20px 20px 80px;
  font-size: 18px;
  color: #000000;
}

.cert-wrap {
  flex-wrap: wrap;
  padding: 0 30px 0 80px;
}

.cert-div {
  margin: 0 13px 13px 0;
}
.cert-image-container {
  width: fit-content;
  border-radius: 8px;
  border: 1px solid #DEDEDE;
  display: flex;
  position: relative;
  flex-direction: column;
  color: #657180;
  font-size: 14px;
  padding: 0 26px 30px 26px;
}

.extranetcert-text-wrap {
  margin: 20px 49px 20px 80px;
  font-size: 18px;
  color: #000000;
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.title-wrap {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  margin-top: 25px;
  justify-content: center;
}
.title-wrap img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.cert-image {
  width: 250px;
  height: 182px;
  margin: 15px 0 25px 0;
}
.osis-cert {
  margin: 15px 0 25px 0;
}

.review-time {
  margin: 15px 0;
}

.review-status-icon{
  width: 72px;
  height: 59px;
  position: absolute;
  right: 0;
}

.sync-btn-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sync-btn-wrap .el-button {
  border-radius: 4px 0px 0px 4px;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  height: 39px;
}
.drop-icon {
  width: 28px;
  display: inline-block;
  color: #FFFFFF;
  height: 100%;
  background: #66B1FE;
  line-height: 39px;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
}

.sync-btn-wrap /deep/ .el-icon-sync-cert {
  background: url("../../../../assets/instmng/attendantlist/img-attendant-sync.png") no-repeat;
  font-size: 16px;
  background-size: cover;
  width: 22px;
  height: 19px;
}

.adopt-cert {
  background: #E4EDFE;
}
.expired-cert {
  background: #EAEAEA;
}

.expired-cert-tag {
  color: #FF4D4F;
}
</style>

<style>
.sync-cert-table {
  max-height: 250px;
  overflow-y: auto;
}

/* 去掉中间数据的分割线 */
.sync-cert-table .el-table__row>td {
  font-size: 12px;
  color: #657180;
  border: none;
}
/* 去掉上面的线 */
.sync-cert-table td.el-table__cell, .sync-cert-table th.el-table__cell.is-leaf {
  border: none;
  padding: 0;
  font-size: 12px;
  color: #657180;
}

/* 去掉最下面的那一条线 */
.sync-cert-table::before,.sync-cert-table::after {
  height: 0px;
}

.sync-cert-table td.el-table__cell .cell{
  margin-top: 8px;
}

</style>


// WEBPACK FOOTER //
// src/components/instmng/components/attendantdetails/AttendantCertInfo.vue